// Simple geo/currency detection for paywall pricing.
// Uses browser timezone (Intl.DateTimeFormat) + language as signals.
// Returns { currency: 'EUR' | 'USD', symbol, price, stripeUrl }.

const EUR_LANGS = new Set([
  'de', 'fr', 'es', 'it', 'nl', 'pt', 'pl', 'sv', 'da', 'fi', 'el', 'cs',
  'hu', 'ro', 'sk', 'sl', 'bg', 'hr', 'et', 'lv', 'lt', 'mt', 'ga',
]);

const STRIPE_USD = 'https://buy.stripe.com/aFa5kC8dP6rF4kSbbx8N207';
const STRIPE_EUR = 'https://buy.stripe.com/8x26oGeCdbLZ7x46Vh8N208';

export function detectPricing() {
  let inEurope = false;
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (tz.startsWith('Europe/')) inEurope = true;
  } catch { /* ignore */ }
  try {
    const lang = (navigator.language || 'en').toLowerCase().split('-')[0];
    if (EUR_LANGS.has(lang)) inEurope = true;
  } catch { /* ignore */ }
  return inEurope
    ? { currency: 'EUR', symbol: '€', price: '€9.99', stripeUrl: STRIPE_EUR }
    : { currency: 'USD', symbol: '$', price: '$9.99', stripeUrl: STRIPE_USD };
}
